/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  // CardActions,
  CardHeader,
  // InputAdornment,
  // IconButton,
  // MenuItem,
  Button,
  CircularProgress,
  Grid,
  TextField
} from '@mui/material';
// import { ExpandMore } from '@mui/icons-material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SettingAction from '../../../store/actions/SettingAction';
// import globalAction from '../../../store/actions/GlobalAction';
import ContentLoader from '../../../utils/errorPages/ContentLoader';
import { ValidateAuthorizeCard } from '../../../assets/validation';
import useHasPermission from '../../../utils/useHasPermission';
import { paymentSettings, index, store } from '../../../utils/constants';
import IOSSwitchStyle from '../../../components/SwitchField';

export default function PaymentAuthorizeNet() {
  const [data, setData] = useState([]);
  const [modeValue, setModeValue] = useState('');

  const dispatch = useDispatch();
  const { authorizeData, isLoading } = useSelector((state) => state.setting); // Replace 'data' with your reducer name
  // const { statusData } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(SettingAction.getAuthorizeNet());
    // dispatch(globalAction.getClientStatus());
  }, [dispatch]);

  useEffect(() => {
    if (authorizeData && authorizeData?.data) {
      setData(authorizeData.data);
      if (authorizeData.data?.AUTHORIZE_MODE) {
        setModeValue(authorizeData.data.AUTHORIZE_MODE);
      }
    }
  }, [authorizeData]);

  const getDirtyValues = (values, initialObject) => {
    const newdata = { ...values };
    const keyValues = Object.keys(newdata);

    const dirtyValues = keyValues.filter(
      (keyValue) => newdata[keyValue] !== initialObject[keyValue]
    );

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete newdata[key];
    });
    return newdata;
  };

  // console.log(typeof data?.AUTHORIZE_MODE, 'sdfdsfsdfs');

  const initialValues = {
    AUTHORIZE_MODE: data?.AUTHORIZE_MODE ?? '',
    AUTHORIZE_SANDBOX_LOGIN_ID: data?.AUTHORIZE_SANDBOX_LOGIN_ID ?? '',
    AUTHORIZE_SANDBOX_TRANSACTION_KEY: data?.AUTHORIZE_SANDBOX_TRANSACTION_KEY ?? '',
    AUTHORIZE_LIVE_LOGIN_ID: data?.AUTHORIZE_LIVE_LOGIN_ID ?? '',
    AUTHORIZE_LIVE_TRANSACTION_KEY: data?.AUTHORIZE_LIVE_TRANSACTION_KEY ?? '',
    AUTHORIZE_IS_ENABLED: data?.AUTHORIZE_IS_ENABLED
  };

  const permissionAccess = !(
    useHasPermission(paymentSettings, index) && useHasPermission(paymentSettings, store)
  );
  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <ContentLoader /> : ''}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={ValidateAuthorizeCard}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          console.log(values, 'values');
          const updateValues = getDirtyValues(values, initialValues);
          dispatch(SettingAction.updateAuthorizeNet(updateValues, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                  <Grid item lg={3} xl={2}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess}>
                        Authorize Mode
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="statusId-label"
                        name="AUTHORIZE_MODE"
                        value={values.AUTHORIZE_MODE}
                        onChange={(e) => {
                          setFieldValue('AUTHORIZE_MODE', e.target.value);
                          setModeValue(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="sandbox"
                          control={<Radio />}
                          label="Sandbox"
                        />
                        <FormControlLabel
                          // disabled={permissionAccess}
                          value="live"
                          control={<Radio />}
                          label="Live"
                        />
                      </RadioGroup>
                    </FormControl>
                    {/* <TextField
                      id="AUTHORIZE_MODE"
                      fullWidth
                      select
                      label="Authorize Mode"
                      name="AUTHORIZE_MODE"
                      margin="normal"
                      value={values.AUTHORIZE_MODE}
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue('AUTHORIZE_MODE', e.target.value);
                        setModeValue(e.target.value);
                      }}
                      // onBlur={handleBlur}
                      error={errors.AUTHORIZE_MODE && touched.AUTHORIZE_MODE}
                      helperText={
                        errors.AUTHORIZE_MODE && touched.AUTHORIZE_MODE && errors.AUTHORIZE_MODE
                      }
                      required={false}
                      InputLabelProps={{ required: !permissionAccess }}
                      // InputProps={{
                      //   endAdornment: (
                      //     <InputAdornment position="start">
                      //       <IconButton
                      //         aria-label="toggle password visibility"
                      //         edge="end"
                      //         disabled
                      //       >
                      //         <HowToRegOutlinedIcon />
                      //       </IconButton>
                      //     </InputAdornment>
                      //   )
                      // }}
                    >
                      <MenuItem value="live">Live</MenuItem>
                      <MenuItem value="sandbox">Sandbox</MenuItem>
                    </TextField> */}
                  </Grid>
                  <Grid item lg={3} xl={3}>
                    <FormControl sx={{ mt: 2, width: '100%', textAlign: 'left' }}>
                      <FormLabel id="statusId" required={!permissionAccess} sx={{ mb: 1 }}>
                        Status
                      </FormLabel>
                      <IOSSwitchStyle
                        size="small"
                        disabled={permissionAccess}
                        checked={values.AUTHORIZE_IS_ENABLED === 1}
                        value={values.AUTHORIZE_IS_ENABLED}
                        // label={values.AUTHORIZE_IS_ENABLED !== 2 ? 'Active' : 'In-active'}
                        onChange={(e) => {
                          console.log(e.target.checked, 'value');
                          if (e.target.checked) {
                            setFieldValue('AUTHORIZE_IS_ENABLED', 1);
                          } else {
                            setFieldValue('AUTHORIZE_IS_ENABLED', 2);
                          }
                        }}
                      />
                    </FormControl>
                    {/* <TextField
                      id="status"
                      fullWidth
                      label="Status"
                      name="AUTHORIZE_IS_ENABLED"
                      margin="normal"
                      select
                      disabled={permissionAccess}
                      value={values.AUTHORIZE_IS_ENABLED}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.AUTHORIZE_IS_ENABLED && touched.AUTHORIZE_IS_ENABLED}
                      helperText={
                        errors.AUTHORIZE_IS_ENABLED &&
                        touched.AUTHORIZE_IS_ENABLED &&
                        errors.AUTHORIZE_IS_ENABLED
                      }
                      required={false}
                      InputLabelProps={{ required: !permissionAccess }}>
                      {statusData &&
                        statusData.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.status}
                          </MenuItem>
                        ))}
                    </TextField> */}
                  </Grid>
                </Grid>
                {modeValue === 'sandbox' ? (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader
                      sx={{ textAlign: 'left !important' }}
                      title="Sandbox Configuration"
                    />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.AUTHORIZE_SANDBOX_LOGIN_ID &&
                              touched.AUTHORIZE_SANDBOX_LOGIN_ID
                            }
                            label="Authorize Sandbox Login ID"
                            className=""
                            disabled={permissionAccess}
                            fullWidth
                            type="text"
                            name="AUTHORIZE_SANDBOX_LOGIN_ID"
                            value={values.AUTHORIZE_SANDBOX_LOGIN_ID}
                            // maxRows={4}
                            placeholder="Enter Login ID"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.AUTHORIZE_SANDBOX_LOGIN_ID &&
                              touched.AUTHORIZE_SANDBOX_LOGIN_ID &&
                              errors.AUTHORIZE_SANDBOX_LOGIN_ID
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.AUTHORIZE_SANDBOX_TRANSACTION_KEY &&
                              touched.AUTHORIZE_SANDBOX_TRANSACTION_KEY
                            }
                            label="Authorize Sandbox Transaction Key"
                            className=""
                            disabled={permissionAccess}
                            fullWidth
                            type="text"
                            name="AUTHORIZE_SANDBOX_TRANSACTION_KEY"
                            value={values.AUTHORIZE_SANDBOX_TRANSACTION_KEY}
                            // maxRows={4}
                            placeholder="Enter Transaction Key"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.AUTHORIZE_SANDBOX_TRANSACTION_KEY &&
                              touched.AUTHORIZE_SANDBOX_TRANSACTION_KEY &&
                              errors.AUTHORIZE_SANDBOX_TRANSACTION_KEY
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                ) : (
                  <Card sx={{ mt: 2, maxWidth: '65%' }}>
                    <CardHeader sx={{ textAlign: 'left !important' }} title="Live Configuration" />
                    <CardContent>
                      <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                        <Grid item lg={6} xl={6}>
                          <TextField
                            id="AUTHORIZE_LIVE_LOGIN_ID"
                            fullWidth
                            type="text"
                            disabled={permissionAccess}
                            label="Authorize Live Login ID"
                            name="AUTHORIZE_LIVE_LOGIN_ID"
                            margin="normal"
                            placeholder="Enter Login ID"
                            value={values.AUTHORIZE_LIVE_LOGIN_ID}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const val = (e.target.value || '').replace(/\s+/gi, '');
                              setFieldValue(e.target.name, val.trim());
                              handleBlur(e);
                            }}
                            error={
                              errors.AUTHORIZE_LIVE_LOGIN_ID && touched.AUTHORIZE_LIVE_LOGIN_ID
                            }
                            helperText={
                              errors.AUTHORIZE_LIVE_LOGIN_ID &&
                              touched.AUTHORIZE_LIVE_LOGIN_ID &&
                              errors.AUTHORIZE_LIVE_LOGIN_ID
                            }
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                        <Grid item lg={6} xl={6}>
                          <TextField
                            error={
                              errors.AUTHORIZE_LIVE_TRANSACTION_KEY &&
                              touched.AUTHORIZE_LIVE_TRANSACTION_KEY
                            }
                            label="Authorize Live Transaction Key"
                            className=""
                            disabled={permissionAccess}
                            fullWidth
                            type="text"
                            name="AUTHORIZE_LIVE_TRANSACTION_KEY"
                            value={values.AUTHORIZE_LIVE_TRANSACTION_KEY}
                            // maxRows={4}
                            placeholder="Enter Transaction Key"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={
                              errors.AUTHORIZE_LIVE_TRANSACTION_KEY &&
                              touched.AUTHORIZE_LIVE_TRANSACTION_KEY &&
                              errors.AUTHORIZE_LIVE_TRANSACTION_KEY
                            }
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: !permissionAccess }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}
              </CardContent>
              {!permissionAccess ? (
                <CardContent
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.06)',
                    p: 2,
                    columnGap: '16px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                      setModeValue(data?.AUTHORIZE_MODE);
                    }}
                  >
                    Clear
                  </Button>
                </CardContent>
              ) : (
                ''
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}
